import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";

import { faCheck, faCode, faCopy } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { translationKeys } from "../../../../../models/app-translation-keys";

import "./CodeBlock.scss";

interface ICodeBlockProps {
  language?: string;
  code: string;
}

export const CodeBlock: FunctionComponent<ICodeBlockProps> = ({ language, code }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const tooltipKeys = translationKeys.feature.chatbot.tooltips.codeBlock;

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="code-block-component">
      <div className="code-block-header">
        <span className="code-block-language">
          <FontAwesomeIcon icon={faCode} className="code-block-language-icon" />
          {language || "code"}
        </span>

        <button className="code-block-copy-button" onClick={handleCopy} title={t(tooltipKeys.copy)} type="button">
          <FontAwesomeIcon icon={copied ? faCheck : faCopy} />
          <span>{copied ? t(tooltipKeys.copied) : t(tooltipKeys.copy)}</span>
        </button>
      </div>

      <SyntaxHighlighter
        language={language}
        style={oneLight}
        PreTag="pre"
        className="code-block-content"
        customStyle={{
          margin: 0,
          padding: "0.9rem 1rem",
          background: "transparent",
          fontSize: "0.875rem",
          lineHeight: 1.55,
        }}
        codeTagProps={{ style: { fontFamily: "inherit" } }}
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
};
